import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../taxDeclaration/listData/ListData.module.css";
import MainContent from "../../layouts/maincontent/MainContent";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import InputElement from "../../shared/form/InputElement";
import { get_list_payments } from "../../adapters/apis/onlinePayment/list";
import Moment from "moment";
import Pagination from "../../shared/pagination/Pagination";
import { jsPDF } from "jspdf";
import * as htmlToImage from "html-to-image";
import logo from "../../assets/img/pdf-logo.png";
import { getPaymentReceipt } from "../../adapters/apis/lookups/lookups";
import { get } from "../../adapters/xhr/api";

// import html2canvas from 'html2canvas';
// import { jsPDF } from 'jspdf';
// import ElectronicPaymentReceipt from "../../components/electronicPayment/PDF/ElectronicPaymentReceipt";

function ListOnlinePayment() {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const [paymentsLength, setPaymentsLength] = useState(0);
  const [declaration_num, setDeclarationNum] = useState(0);
  const [filters, setFilters] = useState({
    unit_code: "",
    offset: limit,
  });
  const navigate = useNavigate();
  // const printRef = useRef();
  // const handleDownloadPdf = async () => {
  //   const element = printRef.current;
  //   const canvas = await html2canvas(element);
  //   const data = canvas.toDataURL('image/png');

  //   const pdf = new jsPDF();
  //   const imgProperties = pdf.getImageProperties(data);
  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight =
  //     (imgProperties.height * pdfWidth) / imgProperties.width;

  //   pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //   pdf.save(`${new Date().toISOString()}.pdf`);
  // };

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const delay = async (ms = 1000) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    setIsLoading(true);
    if (localStorage.getItem("onlinePaymentId")) {
      getPaymentReceipt(localStorage.getItem("onlinePaymentId"))
        .then((res) => {
          if (res.data.data.isConfirmed === "true") {
            setSuccess(
              "تمت عملية الدفع بنجاح ورقم المدفوعة : " +
                res.data.data.paymentRequestNo,
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
      localStorage.removeItem("onlinePaymentId");
    }

    // get tax_declarations for logged user
    get_list_payments({}, 0, {
      unit_code: "",
      offset: limit,
    })
      .then((res) => {
        setPaymentsLength(res?.data?.total);
        setPayments(res?.data?.data);
        setCurrentPage(1);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function callback(active) {
    setIsLoading(true);
    setCurrentPage(active);
    get_list_payments({}, active, filters).then((res) => {
      setPaymentsLength(res?.data?.total);
      setPayments(res?.data?.data);
      setIsLoading(false);
    });
  }
  function search() {
    //call api to get tax declaration with filters

    get_list_payments({}, 1, filters).then((res) => {
      setPaymentsLength(res?.data?.total);
      setPayments(res?.data?.data);
      setCurrentPage(1);
    });
  }
  function changeFilters(parentCompenent, compenent, key, value) {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
  const saveAsPDF = async () => {
    console.log("save p");

    // Get List of paged elements.
    let elems = document.querySelectorAll(".pdf-box");
    const pdf = new jsPDF();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let sumHeight = 15;
    for (let idx = 0; idx < elems.length; idx++) {
      htmlToImage
        .toPng(elems[idx], { quality: 0.95 })
        // eslint-disable-next-line no-loop-func
        .then(function (dataUrl) {
          var link = document.createElement("a");
          link.download = "my-image-name.jpeg";
          const imgProps = pdf.getImageProperties(dataUrl);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          if (idx === 0) {
            pdf.addImage(logo, "PNG", 145, 2, 60, 15);
            pdf.text(declaration_num, 5, 13, 0, 0);
          }
          if (pageHeight <= sumHeight + pdfHeight) {
            pdf.addPage();
            sumHeight = 15;
            pdf.addImage(logo, "PNG", 145, 2, 60, 15);
            pdf.text(declaration_num, 5, 13, 0, 0);
          }
          if (idx < elems.length - 1) {
            pdf.addImage(dataUrl, "PNG", 0, sumHeight, pdfWidth, pdfHeight);
            sumHeight += pdfHeight;
          } else {
            pdf.addImage(dataUrl, "PNG", 0, sumHeight, pdfWidth, pdfHeight);
            pdf.save("TaxDeclartion.pdf");
          }
        });
      await delay(10);
    }
  };
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch("SamplePDF.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "SamplePDF.pdf";
        alink.click();
      });
    });
  };

  const data = payments?.map((element, index) => {
    return (
      <tr key={element?.id}>
        <td data-label="كود الوحدة" className="unit-code">
          #{element.acc_key}
        </td>
        <td data-label="أسم المسدد" className="payer-name">
          {element?.payer_name}
        </td>
        <td data-label="تاريخ السداد" className="payer-date">
          {Moment(element?.date, "A h:mm DD/MM/YYYY").format("DD/MM/YYYY")}
        </td>
        <td data-label="المبلغ المسدد" className="payer-mony">
          {element?.settlementAccountAmount}
        </td>
        <td data-label="حالة السداد" className="payer-status">
          {element?.status}
        </td>
        <td data-label="تفاصيل" className="payer-details">
          <div className="d-flex gap-1 justify-content-center">
            <Link
              to={`/online-payment/details/` + element?.payment_id}
              state={parseInt(element?.online_enquiry_type)}
              className={styles["btn-file"]}
              id="details_button"
            >
              <span className="text d-lg-none d-block" id="details">
                التفاصيل
              </span>
              <span className="icon d-lg-block d-none">
                <i className="fa-regular fa-file-lines fa-2xl"></i>
              </span>
            </Link>
            {element.status_id == 2 && (
              <Link
                id="pdf-Receipt"
                to={"/online-payment/pdf-Receipt/" + element?.id}
                className={`btn-file-print`}
              >
                {/*<button type="button" className={ `btn-file-print` } onClick={onButtonClick}>*/}
                <span className="text d-lg-none d-block">طباعة</span>
                <span className="icon d-lg-block d-none">
                  <i className="fa-solid fa-print fa-2xl"></i>
                </span>
              </Link>
            )}
          </div>
        </td>
      </tr>
    );
  });
  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section className={`${styles.listData} list-payment`}>
          <div className="container pt-5">
            <div className={styles.box}>
              <div className={`${styles["box-header"]}`}>
                <h3 className={`${styles["box-title"]} mb-0`}>أكواد الوحدات</h3>
                <div className={styles["btns-header"]}>
                  <Link
                    to="/online-payment/new-payment"
                    className={styles["btns-header-order"]}
                    id="pay_new_bill"
                  >
                    دفع فاتورة جديدة
                  </Link>
                </div>
              </div>
              <div className={`${styles["box-body"]} mt-3`}>
                <div className={`${styles["box-body-content"]} pt-0`}>
                  {success !== "" && (
                    <div className="row align-items-center">
                      <div className="col-md-12 alert alert-primary">
                        {success}
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-row justify-content-end align-items-center gap-md-5 gap-2 ps-md-3 ps-0">
                    <div className="w-lg-25 w-100">
                      <InputElement
                        name="unit_code"
                        mb4="mb-4"
                        inputType="text"
                        inputClassName={`${styles["form-control"]} form-control`}
                        inputID="unit_code"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        value={filters?.unit_code}
                        onChange={changeFilters}
                        placeholder="كود الوحدة"
                        maxLength="255"
                      />
                    </div>
                    <div className="flex-shrink-1">
                      <button
                        className={`${styles["btns-search"]} btn-search-payment`}
                        onClick={search}
                        id="search_button"
                      >
                        بحث
                      </button>
                    </div>
                  </div>
                  <div
                    className={`${styles["table-responsive"]} table-responsive`}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">كود الوحدة</th>
                          <th scope="col">أسم المسدد</th>
                          <th scope="col">تاريخ السداد</th>
                          <th scope="col">المبلغ المسدد</th>
                          <th scope="col">حالة السداد</th>
                          <th scope="col">تفاصيل</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length > 0 ? (
                          data
                        ) : (
                          <tr>
                            <td colSpan={6} className="h5">
                              لا توجد مدفوعات
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {paymentsLength > limit ? (
                <Pagination
                  limit={limit}
                  count={paymentsLength}
                  active={currentPage}
                  callback={callback}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </section>
      )}
      {/* <div ref={ printRef }>
        <ElectronicPaymentReceipt />
      </div> */}
    </MainContent>
  );
}
export default ListOnlinePayment;
